import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ValidationMessageType , ValidationMessageRowComponent } from "~app/common/validation/validation-message-row/validation-message-row.component";

export interface IWarningText {
    text: string;
    type: ValidationMessageType;
}

@Component({
    selector: "rask-beraknat-utbyte-validation",
    templateUrl: "./beraknat-utbyte-validation.component.html",
    styleUrls: ["./beraknat-utbyte-validation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ValidationMessageRowComponent]
})

export class BeraknatUtbyteValidationComponent {
    @Input() warnings: IWarningText[]=[];
}
